const SESSION_STORAGE_KEY = "impersonationSessionId";
const QUERY_PARAM = "impersonationSessionId";

const impersonationHelper = {
  captureSessionIdFromUrl(): void {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get(QUERY_PARAM);
    if (!sessionId) {
      return;
    }

    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    params.delete(QUERY_PARAM);
    const remaining = params.toString();
    const newUrl =
      window.location.pathname +
      (remaining ? `?${remaining}` : "") +
      window.location.hash;
    window.history.replaceState({}, "", newUrl);
  },

  getSessionId(): string | null {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
  },

  clearSessionId(): void {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  },

  isImpersonationTab(): boolean {
    return impersonationHelper.getSessionId() != null;
  },

  buildLaunchUrl(launchPath: string): string {
    const path = launchPath.startsWith("/") ? launchPath : `/${launchPath}`;
    return `${window.location.origin}${path}`;
  },
};

export default impersonationHelper;
